import type {ThesaurusId} from '../types';

export const useAllThesaurusIds = (): ThesaurusId[] => {
  return ['genreandform', 'bokbasen', 'grep', 'thema', 'neo'];
};
